<template>
    <div class="w-full px-4 py-4">
        <label
            for="coupon_code"
            class="flex items-center text-sm text-gray-500"
        >
            Coupon Code
            <a href="/coupons/send" class="hover:text-nutreance-green">
                <QuestionMarkCircleIcon
                    class="h-4 w-4 ml-1"
                    aria-hidden="true"
                />
            </a>
        </label>
        <div class="mt-1 flex rounded-md shadow-sm">
            <div class="relative flex items-stretch grow focus-within:z-10">
                <input
                    @focus="message = ''"
                    @keydown.enter="applyCoupon(inputs)"
                    v-model="inputs.coupon_code"
                    name="coupon_code"
                    id="coupon_code"
                    type="text"
                    :class="[
                        errors.coupon_code
                            ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10 z-10'
                            : 'focus:ring-nutreance-green focus:border-nutreance-green',
                        'block w-full pr-3 py-2 rounded-none rounded-l-md border border-gray-300 focus:outline-none sm:text-sm',
                    ]"
                    :aria-invalid="errors.coupon_code ? 'true' : 'false'"
                    :aria-describedby="
                        errors.coupon_code ? 'coupon_code-error' : ''
                    "
                />
                <div
                    v-if="errors.coupon_code"
                    class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none z-10"
                >
                    <ExclamationCircleIcon
                        class="h-5 w-5 text-red-500"
                        aria-hidden="true"
                    />
                </div>
            </div>

            <button
                type="button"
                name="apply_coupon_code"
                @click="applyCoupon(inputs)"
                class="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none"
            >
                <LoadingIcon
                    v-if="loading"
                    class="h-5 w-5 mr-2 text-gray-400"
                />
                <CheckIcon
                    v-else
                    class="h-5 w-5 mr-2 text-gray-400"
                    aria-hidden="true"
                />
                <span>Apply</span>
            </button>
        </div>
        <p
            v-if="errors.coupon_code"
            class="mt-2 text-sm text-red-600"
            id="coupon_code-error"
        >
            {{ errors.coupon_code }}
        </p>
        <p
            v-if="message"
            class="mt-2 text-sm text-nutreance-green"
            id="coupon_code-message"
        >
            {{ message }}
        </p>
    </div>
</template>

<script setup lang="ts">
import { inject, onMounted, reactive, ref } from "vue";
import type { AppEmitter } from "../../emitter";
import {
    CheckIcon,
    ExclamationCircleIcon,
    QuestionMarkCircleIcon,
} from "@heroicons/vue/solid";
import { useCoupon } from "../../functions/useCoupon";
import LoadingIcon from "../LoadingIcon.vue";

defineProps<{
    errors?: any;
}>();

const emitter = inject<AppEmitter>("mitt")!;
const { loading, applyCoupon } = useCoupon();

const inputs = reactive<{ coupon_code: any }>({
    coupon_code: null,
});

const message = ref<string | null>(null);

onMounted(() => {
    emitter.on("couponApplied", () => {
        inputs.coupon_code = null;
        message.value = "Coupon applied!";
    });
});
</script>
